export function throttle(func, wait, { leading = false, trailing = false }) {
  let context, args, result;
  let timeout = null;
  let previous = 0;

  const later = function () {
    previous = leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);

    if (!timeout) {
      context = null;
      args = null;
    }
  };

  return function () {
    const now = Date.now();
    if (!previous && leading === false) {
      previous = now;
    }

    const remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);

      if (!timeout) {
        context = null;
        args = null;
      }

    } else if (!timeout && trailing !== false) {
      timeout = setTimeout(later, remaining);
    }

    return result;
  };
}

export function createEvent(name, detail = undefined) {
  if (typeof window.CustomEvent === 'function') {
    return new window.CustomEvent(name, {
      bubbles: true,
      cancelable: true,
      detail,
    });
  }

  const evt = document.createEvent('CustomEvent');
  evt.initCustomEvent(name, true, true, detail);

  return evt;
}

export function isEnterKey(event) {
  return event.code === 'Enter' || event.keyCode === 13;
}

export function isSpaceKey(event) {
  return event.code === 'Space' || event.keyCode === 32;
}

export function isEscapeKey(event) {
  return event.code === 'Escape' || event.keyCode === 27;
}
